import React from "react";
import * as d3 from "d3"
import "../../styles/Bubble.css"
import axios from "axios";
import {API} from "../../service/api";
import ExplanationNote from "./ExplanationNote";
import legend from "../../Icons/website legend.png";
const cid = sessionStorage.getItem("cid")

const myColor = d3.scaleLinear().domain([0,0.5,1])
  .range(["#E1BE6A", "#F9F5FF", "#40B0A6"])
const colors = {
    positive: '#40B0A6',
    negative: '#E1BE6A',
    assignment: '#F16529',
    grading: '#1C88C7',
    workload: '#FCC700',
    generalFeeling: '#e2d1ff',
    instructor: '#fff',
    TA: '#fff',
    lab: '#fff',
    recitation: '#fff',
    courseDesign: '#fff',
    exam: '#fff',
    content: '#fff',
    participation: '#fff',
    groupWork: '#fff',
    resources: '#fff',
    lessonsLearned: '#fff',
    officeHour: '#fff',
    skills: '#fff',
    delivery: '#fff',
    personality: '#fff',
};

const BubbleView = (props) =>{
    const qid = props.qid;

    const explanation = ["How are aspects generated?",
    "We used a weakly-supervised aspect extraction model to categorize comment sentence into pre-defined sentiments."]

    const bubbleRef = React.createRef();
    const tooltipRef = React.createRef();
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight*0.9,
        width: window.innerWidth*0.9
      })

    const [loading, setLoading] = React.useState(true);

    const generateChart = (data, width, height) => {

    const div = d3.select(bubbleRef.current)
    const svg = div.append('svg')
        .attr("id","bubble-pack")

        svg.style('width', width)
            .style('height', height)
            // .style('position', 'absolute')
            // .style('bottom', '30vh')
            // .style('left', '10vw')

        const bubble = data => d3.pack()
            .size([width*0.9, height*0.8])
            .padding(15)(d3.hierarchy({ children: data }).sum(d => d.score));

        const root = bubble(data);
        const tooltip = d3.select(tooltipRef.current);

        const node = svg.selectAll()
            .data(root.children)
            .enter().append('g')
            .attr('transform', `translate(${width / 2}, ${height / 2})`);

        const circle = node.append('circle')
            // .style('fill', d => colors[d.data.sentiment])
            .style('fill', d => myColor(d.data.sentimentScore))
            .on('mouseover', function (e, d) {
                tooltip.select('a').attr('href', d.data.link);
                tooltip.select('div').attr('class', d.data.category)
                    .html(function(){
                        let summary = `<h5 style="text-align: center; font-weight: bold">${d.data.name}</h5>`

                        let tempcolor = (d.data.sentimentScore > 0.5)?"#40B0A6":"#E1BE6A"
                        summary += `<div style="color: ${tempcolor}">${Math.round(d.data.sentimentScore*100)}% ${d.data.sentiment}</div>`
                        summary += `<div>Top sentences related to ${d.data.name}</div>`
                        summary += `<div style="display: block; height: 1px; background-color: black; width: 100%; margin: 2px"></div>`
                        summary += '<div style="text-align: left">'
                        let lines = d.data.summary.split("[SEP]")
                        lines.pop()
                        for (let i=0;i<lines.length;i++){
                            summary += (i+1) + ": " + lines[i] + "<br />"

                        }
                        // summary += "<br /> <span style='color: black'>[click the bubble to view more details inside] </span><br />"
                        summary +='</div>'
                        return(summary)
                    }).style('text-align', 'left');
                tooltip.style('visibility', 'visible');
                tooltip.style('width', "40vw");
                tooltip.style('position', 'fixed');
                tooltip.style('top', '20vh');
                tooltip.style('right', '7vw');
                tooltip.style('background-color', '#fff');
                tooltip.style('padding', '2em')
                tooltip.style('box-shadow', '0 3px 10px rgb(0 0 0 / 0.2)')
                tooltip.style('z-index', '9999')

                d3.select(this).style('stroke', '#222');
            })
            // .on('mousemove', e => tooltip.style('top', `${e.pageY}px`)
            //                              .style('left', `${e.pageX + 10}px`))
            .on('mouseout', function () {
                d3.select(this).style('stroke', 'none');
                return tooltip.style('visibility', 'hidden');
            })
            .on('click', (e, d) => {
                window.open(d.data.link,"_self")
                sessionStorage.setItem("category", d.data.category);
                sessionStorage.setItem("summary", d.data.summary);
            });

        const label = node.append('text')
            .attr('dy', 2)
            .style('text-anchor', 'middle')
            .style('font', '0.9em sans-serif')
            .style('pointer-events', "none")
            .style('opacity', 0)
            .text(d => d.data.name.substring(0, d.r / 2));

        node.transition()
            .ease(d3.easeExpInOut)
            .duration(1000)
            .attr('transform', d => `translate(${d.x}, ${d.y})`);

        circle.transition()
            .ease(d3.easeExpInOut)
            .duration(1000)
            .attr('r', d => d.r);

        label.transition()
            .delay(700)
            .ease(d3.easeExpInOut)
            .duration(1000)
            .style('opacity', 1)
    };

    React.useEffect(() =>{
        function handleResize(){
              d3.select("#bubble-pack").remove();
              let container = document.getElementById("svg-container")
              setDimensions({
                height: container.clientHeight*1.1,
                width: container.clientWidth*1.1
              })
        }
        window.addEventListener('resize', handleResize)
    }, [])

    React.useEffect(() =>{
        if(sessionStorage.getItem(`${qid}Bubble`)!=null){
            let bubbleData = JSON.parse(sessionStorage.getItem(`${qid}Bubble`))
            setLoading(false)
            generateChart(bubbleData, dimensions.width, dimensions.height)
        }else{
            axios({
              method: 'get',
              url: `${API}/Bubbles/${qid}-${cid}`,
            }).then(function (response) {
                sessionStorage.setItem(`${qid}Bubble`, JSON.stringify(response.data.data))
                setLoading(false)
            }).catch((error) =>{
                console.log(error)
            })
        }

    }, [dimensions, loading])

    React.useEffect(()=>{
        if(sessionStorage.getItem(`${qid}Scatter`)==null){
            axios({
              method: 'get',
              url: `${API}/Scatters/${qid}-${cid}`,
            }).then(function (response) {
                  sessionStorage.setItem(`${qid}Scatter`, JSON.stringify(response.data.data))
            })
        }
    },[])

    return(
        <>
                <h4 style={{marginTop: "2em"}}>Distribution of Comments Across Prevalent Topics</h4>
                <div>Hover over bubbles to see top related sentences
                    <br />Click bubbles or the tabs below to view details</div>
                    <div style={{paddingLeft: "20vw", paddingRight:"20vw"}}><ExplanationNote style={{backgroundColor: "transparent"}} data={explanation}/></div>
                <div className={"row-block"} style={{paddingTop: "0.5em"}}>*Size of bubble: Prevalence of the topic among the comments</div>
                {/*<div className={"row-block"} style={{paddingTop: 0, justifyContent:"flex-start", alignItems: "center"}}>*/}
                {/*    <div style={{minWidth: "1em", minHeight:"1em", backgroundColor:"#83ce5c", padding: "0.5em", marginRight: "1em"}}>Positive Sentiment</div>*/}
                {/*    <div style={{minWidth: "1em", minHeight:"1em", backgroundColor:"#F16529", padding: "0.5em"}}>Negative Sentiment</div>*/}
                {/*</div>*/}

            <div className={"row-block"}>
                <div id={"svg-container"} style={{width: "90vw", height: "80vh", paddingTop:0}}>

                    {loading?<div>loading...</div>:
                    <div style={{display: "flex"}}>
                        <div style={{height: "70vh", position: "relative", left: "20vw", paddingLeft: "5vw"}}>
                            <div style={{color: "#40B0A6"}}>Positive Sentiment</div>
                             <img style={{height: "65vh"}} src={legend}/>
                            <div style={{color: "#E1BE6A"}}>Negative Sentiment</div>
                        </div>
                        <div ref={bubbleRef}></div>
                    </div>}
                    <div ref={tooltipRef}>
                        <div>
                            <a className={"bubble-link"}></a>
                            <span className={"bubble-text"}></span>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )

}

export default BubbleView;